import { builtInTemplates as builtInEdgelessTemplates } from '@hive/templates/edgeless';
import { builtInTemplates as builtInStickersTemplates } from '@hive/templates/stickers';
import {
  EdgelessTemplatePanel,
  type TemplateManager,
} from '@blocksuite/hive/gfx/template';

export function registerTemplates() {
  EdgelessTemplatePanel.templates.extend(
    builtInStickersTemplates as TemplateManager
  );
  EdgelessTemplatePanel.templates.extend(
    builtInEdgelessTemplates as TemplateManager
  );
}
